/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import TradeItem from '../TradeItem';
import styles from './styles.module.scss';
import sharedStyles from '../styles.module.scss';

function Headers() {
  const { t } = useTranslation();
  return (
    <thead className={sharedStyles.tableHeader}>
      <tr className={sharedStyles.tableRow}>
        <th className={styles.triangleHeadCell} />
        <th className={sharedStyles.tableCell}>
          <TradeItem muted rightAligned>
            {t('common_price')}
          </TradeItem>
        </th>

        <th className={sharedStyles.tableCell}>
          <TradeItem muted rightAligned>
            {t('common_amount')}
          </TradeItem>
        </th>

        <th className={sharedStyles.tableCell}>
          <TradeItem muted rightAligned>
            {t('common_time')}
          </TradeItem>
        </th>
      </tr>
    </thead>
  );
}

export default memo(Headers);
